import AlphaButtons from './AlphaButtons';

export { type AlphaButtonsProps } from './AlphaButtons';
export default AlphaButtons;
